import createHTMLMediaHook from './util/createHTMLMediaHook';
var useAudio = createHTMLMediaHook('audio');
export default useAudio;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/esm/useAudio.js
// module id = ./node_modules/react-use/esm/useAudio.js
// module chunks = main